function transformTrackingId(trackingId) {
    if (trackingId && !Array.isArray(trackingId)) {
        trackingId = trackingId.split(',').map(id => id.trim());
    }
    return trackingId;
}

module.exports = transformTrackingId;
